import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

function DemoWidgetPage() {
  const { slug } = useParams();
  const [config, setConfig] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const normalizeApiUrl = (raw) => {
      if (!raw) return '/api';
      const trimmed = String(raw).trim();
      if (!trimmed) return '/api';
      if (trimmed.startsWith('/')) return trimmed.replace(/\/$/, '');
      const clean = trimmed.replace(/\/$/, '');
      return clean.endsWith('/api') ? clean : `${clean}/api`;
    };

    const apiUrl = normalizeApiUrl(
      process.env.REACT_APP_WIDGET_API_URL ||
      process.env.REACT_APP_BACKEND_URL ||
      ''
    );

    // Fetch municipality config by slug
    fetch(`${apiUrl}/demo-config/${encodeURIComponent(slug)}`)
      .then((res) => {
        if (!res.ok) throw new Error(`Municipality "${slug}" not found`);
        return res.json();
      })
      .then((data) => {
        setConfig(data);

        // Load widget.js with dynamic config
        const script = document.createElement('script');
        script.src = '/widget.js';
        script.async = true;
        script.setAttribute('data-city', data.name);
        script.setAttribute('data-locale', 'de');
        script.setAttribute('data-widget-id', data.widget_id);
        script.setAttribute('data-api-url', apiUrl);
        document.body.appendChild(script);
      })
      .catch((err) => {
        setError(err.message);
      });

    return () => {
      const existingScript = document.querySelector('script[src="/widget.js"]');
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, [slug]);

  if (error) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#0b1628',
          color: 'white',
        }}
      >
        <img
          src="/logo-stadtki-negative.png"
          alt="StadtKI"
          style={{ height: '200px', width: 'auto', marginBottom: '1.5rem' }}
        />
        <p style={{ fontSize: '1.1rem', color: 'rgba(203,213,245,0.7)' }}>
          Diese Demo ist nicht verfügbar.
        </p>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background:
          'radial-gradient(circle at top right, rgba(56,189,248,0.08), transparent 55%), #0b1628',
        color: 'white',
      }}
    >
      <img
        src="/logo-stadtki-negative.png"
        alt="StadtKI"
        style={{ height: '400px', width: 'auto', marginBottom: '1.5rem' }}
      />
      <p style={{ fontSize: '0.95rem', color: 'rgba(203,213,245,0.7)', textAlign: 'center', maxWidth: '420px' }}>
        {config ? `KI-Assistent der ${config.name}` : 'Wird geladen...'}
      </p>
    </div>
  );
}

export default DemoWidgetPage;
